import {FC, useRef, useState} from 'react'
import {IProductTableFilter, ProductsTableFilterInitialState} from '../cors/_models'
import TextTableFilter from '../../common/TextTableFilter'
import {useSearchParams} from 'react-router-dom'
import { useIntl } from 'react-intl'

interface IProps {
  // setResultFilters: React.Dispatch<React.SetStateAction<IProductTableFilter>>
  // resultFilters: IProductTableFilter
}


export const DraftsTableFilter: FC<IProps> = ({}) => {
  const {formatMessage} = useIntl();
  const [searchParams, setSearchParams] = useSearchParams()
  const [nameFilter, setNameFilter] = useState(searchParams.get('product_name_filter') || '')
  const [barcodeFilter, setBarcodeFilter] = useState(searchParams.get('filter_barcode') || '')
  const [modelFilter, setModelFilter] = useState(searchParams.get('model_filter') || '')

  const handleChange = (id: string, value: string, type: string) => {
    if (value) {
      searchParams.set(id, value)
      searchParams.set('current_page', '1')
    } else {
      searchParams.delete(id)
    }
  }

  const filter = (): void => {
    setSearchParams(searchParams,{
      replace:true
    })
  }
  
  const clearFilters = (): void => {
    setSearchParams({},{
      replace:true
    })
    setNameFilter('')
    setBarcodeFilter('')
    setModelFilter('')
  }

  return (
    <>
      <div className='card-body border-bottom pb-10 mb-5'>
        <div className='row'>
          {/* start product Name */}
          <TextTableFilter
            id='product_name_filter'
            label={formatMessage({ id: "prod_name" })}
            value={nameFilter}
            setValue={setNameFilter}
            onChange={handleChange}
            delay={0}
          />
          {/* end product Name */}

          {/* start BARCODE */}
          <TextTableFilter
            id='filter_barcode'
            label={formatMessage({ id: "barcode" })}
            value={barcodeFilter}
            setValue={setBarcodeFilter}
            onChange={handleChange}
            delay={0}
          />
          {/* end BARCODE */}

          {/* start MODEL */}
          <TextTableFilter
            id='model_filter'
            label={formatMessage({ id: "model" })}
            value={modelFilter}
            setValue={setModelFilter}
            onChange={handleChange}
            delay={0}
          />
          {/* end MODEL */}

          <div className='col-sm-12 col-md-3'>
            <button
                className='btn btn-light mt-md-10 w-100 fs-6 fw-semibold'
                onClick={filter}
            >
              {formatMessage({ id: "filter" })}
            </button>
          </div>

          {/* reset button */}
          <div className='col-sm-12 col-md-3'>
            <button
              type='reset'
              className='btn btn-light mt-md-10 w-100 fs-6 fw-semibold'
              onClick={clearFilters}
            >
              {formatMessage({ id: "reset" })}
            </button>
          </div>
          {/* reset button # */}
        </div>
      </div>
      
    </>
  )
}

export default DraftsTableFilter
